export enum ActionTypes {
  LOG_IN = "log_in",
  LOG_OUT = "log_out",
  SET_USER = "set_user",
  SET_NAME = "set_name",
  LOG_IN_MODAL_OPEN = "log_in_modal_open",
  LOG_IN_MODAL_CLOSE = "log_in_modal_close",
}
